import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-shared',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shared.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './shared.component.css',
})
export class SharedComponent {}
